import { namespace } from 'vuex-class';
import { IRecipientState } from '@/dealroom/recipients/store/recipient.types';

export const recipientNamespace = 'dealroom/recipient';

export const DealroomRecipient = namespace(recipientNamespace);

export enum ERecipientAction {
  SetModalVisibility = 'setModalVisibility',
  OpenRecipientToRoleModal = 'openRecipientToRoleModal',
  SearchRecipientToAssign = 'searchRecipientToAssign',
  SetRecipientModalInfo = 'SetRecipientModalInfo',
  SetIsLoading = 'setIsLoading',
}

export enum ERecipientMutation {
  SetModalVisibility = 'setModalVisibility',
  OpenRecipientToRoleModal = 'openRecipientToRoleModal',
  UpdateSearchRecipientResult = 'UpdateSearchRecipientResult',
  UpdateEditRecipient = 'UpdateEditRecipient',
  SetIsLoading = 'setIsLoading',
}

export const state: IRecipientState = {
  showModal: false,
  showRecipientToRoleModal: false,
  searchRecipientList: [],
  recipientModalInfo: null,
  isLoading: false,
};
